export default __webpack_public_path__ + "static/media/salesRep.f725663e.svg";